// Voucher code validation + generation.
//
// Codes are uppercase alphanumeric plus hyphens/underscores, 3–50 chars per
// FORMS.md §14.1 Zod schema. The generator excludes visually ambiguous glyphs
// (O/0/I/1/L) so staff can read them back over the phone without errors.

const VOUCHER_CODE_REGEX = /^[A-Z0-9_-]{3,50}$/;

export function isValidVoucherCode(code: string): boolean {
  return VOUCHER_CODE_REGEX.test(code);
}

const SAFE_ALPHABET = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'; // no O/0/I/1/L

/**
 * Generate a random voucher code. Uses `crypto.getRandomValues` where
 * available; falls back to `Math.random` for SSR / tests.
 */
export function generateVoucherCode(length = 8): string {
  const safeLength = Math.min(Math.max(length, 4), 20);
  const out: string[] = [];

  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const buf = new Uint32Array(safeLength);
    crypto.getRandomValues(buf);
    for (let i = 0; i < safeLength; i++) {
      out.push(SAFE_ALPHABET[buf[i] % SAFE_ALPHABET.length]);
    }
  } else {
    for (let i = 0; i < safeLength; i++) {
      out.push(SAFE_ALPHABET[Math.floor(Math.random() * SAFE_ALPHABET.length)]);
    }
  }
  return out.join('');
}
